import React from 'react'

import { Tree, Container, FieldSet, Button } from '@sencha/ext-modern'
// import _ from 'lodash'

import { getListFromValues, reconfigButton } from '../../../utility'
import { renderColumn, getModel, handleItemContextMenu, getViewModel } from '../../column'
import { genFullListName, getMixedProps } from './blockPublic'

class TreeGrid extends React.Component {
	handleSelect = (grid) => {
		const { config: { field: { onSelect } } } = this.props

		onSelect && onSelect(grid.getSelections())
	}


	handleStoreChange = (grid, store) => {
		grid && store && this.handleSelect(grid)
	}


	handleColumnSort = (grid, column, direction) => {
		this.sort = [{ property: column.config.dataIndex, direction }]
	}

	handlePainted = grid => {
		if (!(grid.isVisible() && grid.dataItems.length))
			return

		grid.getColumns().forEach(col => col.measureWidth() /* col.getComputedWidth() !== col.el.measure('w') && col.setComputedWidth(col.el.measure('w')) */)
	}

	componentDidMount = () => {
		const selectable = this.refTree && this.refTree.getSelectable()
		const { name, id } = this.props.config.field.default || {}
		const defaultItem = this.refTree && this.refTree.store.byIdMap[`${name}_${id}`]
		selectable && defaultItem && selectable.select(defaultItem)
	}

	render = () => {
		const {
			field: { label, trees, list: listConf, columns, contextmenu, onDoubleTap, buttons, hideHeaders = undefined, viewModel = false, ...field },
			/* onChange,  */initValues, changedValues, defaultStyle, that
		} = this.props.config
		const { props: { defaultIcon, defaultExpand, ...props } } = getMixedProps('_treegrid', [defaultStyle, field])
		!label && (props.padding = '5px 0px 5px 0px')

		const { rowNumbers = false, columnLines = false, minRows = 2, maxRows = Number.MAX_VALUE, height, root = { visible: false, text: Tyan.t('全部') } } = field

		const data = getTreeDataFromValues(trees, initValues, changedValues, listConf, defaultIcon, defaultExpand)
		let store = this.store

		if (!_.isEqual(data, this.oldData)) {
			this.oldData = _.cloneDeep(data)

			const rootData = { _id: '_root', expanded: true, _treeData: root.text, iconCls: root.icon && `x-fa fa-${root.icon}`, children: data, }


			// 保持原有数据的展开状态
			recalExpanded(rootData, store && store.byIdMap || {})

			store = this.store = new Ext.data.TreeStore({
				model: getModel(viewModel ? null : columns, { idProperty: '_id' }),
				rootVisible: root.visible,
				root: rootData
			})

			let sort = []
			trees && trees.forEach(tree => tree.sort && (Array.isArray(tree.sort) ? (tree.sort.forEach(o => sort.push({ property: o }))) : sort.push({ property: tree.sort })))

			sort.length && store.sort(sort)
		}

		// window.store = store

		// 计算高度，如果设置了height，则忽略 maxRows（Number.MAX_VALUE)
		const compHeightProps = {}
		const optGridProps = {}

		optGridProps.minHeight = (hideHeaders ? 2 : 45) + 41 * minRows - 2
		height
			? optGridProps.flex = 1
			: optGridProps.maxHeight = (hideHeaders ? 2 : 45) + 41 * maxRows - 2

		// rowNumbers && (optGridProps.rowNumbers = { width: `${store ? (32 + Math.floor(Math.log10(store.data.length || 1)) * 7) : 32}px` })
		rowNumbers && (optGridProps.rowNumbers = { width: '40px' })
		columnLines && (optGridProps.columnLines = true)
		hideHeaders && (optGridProps.hideHeaders = true)

		contextmenu && (optGridProps.onChildContextMenu = optGridProps.onChildLongPress = (grid, { record, event }) => handleItemContextMenu(contextmenu, grid, record, event, that))
		onDoubleTap && (optGridProps.onChildDoubleTap = (grid, { record }) => onDoubleTap(record.data, record, grid, that))

		columns.find(col => col._richtext != undefined) && (optGridProps.variableHeights = true)

		return <FieldSet title={label} {...props} layout='vbox' {...compHeightProps} errorTarget={undefined}>
			<Tree {...optGridProps} ref={ref => ref && (/* window.refTree =  */this.refTree = ref.cmp)}
				style={{ borderStyle: 'solid', borderWidth: '1px', borderColor: '#e2e2e2' }}
				shadow={false}
				width="100%"
				scrollable
				store={store}
				itemConfig={{
					viewModel: viewModel ? getViewModel(columns) : {}
				}}
				selectable={{ mode: 'single' }}
				onSelect={this.handleSelect}
				onDeselect={this.handleSelect}
				onStoreChange={this.handleStoreChange}
				onPainted={this.handlePainted}
			>
				{columns.map((column, key) => renderColumn(column, key, that, viewModel))}
			</Tree>
			{
				buttons && <Container layout={{ type: 'hbox', pack: 'end' }} margin="10px 0px 0px 0px" width="100%">
					{buttons.map((o1, i) => {
						const o = reconfigButton(o1)
						const { props: btnProps } = getMixedProps('_button', [o])
						o.disabled && typeof o.disabled === 'function' && (btnProps.disabled = o.disabled())
						o.icon != undefined && (typeof o.icon === 'function' ? (btnProps.iconCls = `x-fa fa-${o.icon()}`) : btnProps.iconCls = `x-fa fa-${o.icon}`)
						btnProps.margin = '0px 0px 0px 20px'
						return o.cdt && !o.cdt() ? null : <Button key={i} text={o._button} {...btnProps} />
					})}
				</Container>
			}
		</FieldSet >
	}
}

const recalExpanded = (data, idMap) => {
	if (data.children && data.children.length) {
		idMap[data._id] && (data.expanded = idMap[data._id].data.expanded)
		data.children.forEach(d => recalExpanded(d, idMap))
	}
}

const getTreeDataFromValues = (trees, initValues, changedValues, listConf, defaultIcon, defaultExpand) => {
	const currentValues = { ...initValues, ...changedValues }

	const maps = []
	const lists = []
	// const lastIndex = trees.length - 1

	const data = []

	trees.forEach((tree, index) => {
		const name = genFullListName(listConf, tree.name)
		const value = currentValues[name] || []

		const { list, map } = getListFromValues(name, value, initValues, changedValues)
		lists[index] = list
		maps[index] = map

		// 设置_parentID
		const prevMap = maps[index - 1]

		for (const item of list) {
			// 处理节点
			// 填充'_treeData'用于显示TreeColumn，设置 _id 为 ${name}_${id}, icon
			// Object.keys(map).forEach(id => {
			item._treeData = tree.treeField ? item[tree.treeField] : item.id
			item._id = `${name}_${item.id}`
			item._name = name
			const icon = item.icon || tree.icon || defaultIcon
			icon && (item.iconCls = `x-fa fa-${typeof icon === 'function' ? icon(item) : icon}`)
			const expanded = item.expanded === undefined
				? tree.expanded === undefined
					? defaultExpand
					: tree.expanded
				: item.expanded
			// console.log('default:', expanded, item.expanded, tree.expanded, defaultExpand)
			item.expanded = typeof expanded === 'function' ? expanded(item) : expanded
			// })

			let itemParent = null
			/**
			 * 20210126:
			 * 在20201204处理_treeSelect时，将item[tree.groupID] 判断 修改为 item[tree.groupID] != undefined && item[tree.groupID] !== null
			 * 原因未知，但造成广州三菱的Form中使用_treeGrid时，无上级GroupID时值为0时处理，
			 * 现改加成判断 item[tree.groupID]
			 * 需关注各项目使用_treeSelect时有无出错情况
			 * 20200126：
			 * 原因查明：_treeselect为单层树，会送入id=0的内容来做根节点
			 * 处理方法：增加判断:item[tree.groupID] == 0 && map[0]存在
			 */
			if (tree.groupID && (item[tree.groupID] || item[tree.groupID] == 0 && map[0])) {
				if (!(itemParent = map[item[tree.groupID]])) {
					console.error(`${tree.name} ${item.id} 的组节点 ${item[tree.groupID]} 不存在`, item)
					continue
				}
			} else if (index > 0 && tree.parentID && item[tree.parentID]) {
				if (!(itemParent = prevMap[item[tree.parentID]])) {
					console.error(`${tree.name} ${item.id} 的父节点 ${item[tree.ParentID]} 不存在`, item)
					continue
				}
			}
			itemParent && (itemParent.children = itemParent.children || [], itemParent.children.push(item))
			!itemParent && (index == 0 ? data.push(item) : console.error(`${tree.name} ${item.id} 不存在父节点或组节点`, item))
		}
	})

	// 遍历数据，如果没有子项，设置leaf
	return setLeafOrExpanded(data)
}

const setLeafOrExpanded = (data) => {
	data.forEach(item => {
		item.children && item.children.length > 0 && /* (item.expanded = true) &&  */setLeafOrExpanded(item.children);
		; (!item.children || item.children.length == 0) && (delete item.expanded, item.leaf = true)
	})
	return data
}

const renderTreeGrid = config => {
	const { key } = config.field || {}
	return <TreeGrid key={key} config={config} />
}


export default renderTreeGrid